<template>
    <div class="bn-inquiry-wrap">
        <div
            class="bn-inquiry le-heading5-5 d-flex flex-column align-center justify-center text-center"
            :class="{'tablet': isTablet }"
        >
            <p :class="{ 'mb-2': $vuetify.breakpoint.mdAndUp, 'mb-3': $vuetify.breakpoint.smAndDown }">
                {{ $t('fbn.texts.text1') }}<br v-if="$vuetify.breakpoint.smAndDown"> {{ $t('fbn.texts.text2') }}
            </p>

            <p
                class="le-text-body3"
                :class="{ 'mb-6': $vuetify.breakpoint.mdAndUp, 'mb-5': $vuetify.breakpoint.smAndDown }"
            >
                {{ $t('fbn.texts.text3') }}<br v-if="$vuetify.breakpoint.smAndDown"> {{ $t('fbn.texts.text4') }}
            </p>

            <v-btn
                :to="{ name: 'ContactPage' }"
                color="blue4"
                depressed
                :small="!$vuetify.breakpoint.mdAndUp"
                class="text-white1"
            >
                {{ $t('fbn.btns.btn1') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import { isMobile, isTablet } from 'mobile-device-detect';

export default {
    name: 'Inquiry',

    data: function() {
        return {
            isMobile: isMobile,
            isTablet: isTablet,
        };
    },

    mounted() {
        //
    },

    methods: {
        //
    }
};
</script>